import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CompanyContext } from 'context/Context';
import useCompany from 'hooks/useCompany';

const CompanyProvider = ({ children }) => {
 const { data, dataCompany, isLoading, setDatacompany } = useCompany();
 const [user, setUser] = useState({});
 const [step, setStep] = useState(1);
 const [nit, setNit] = useState(true);

 const value = { user, setUser, step, setStep, nit, setNit, data, dataCompany, isLoading, setDatacompany };

 return <CompanyContext.Provider value={value}>{children}</CompanyContext.Provider>;
};

CompanyProvider.propTypes = {
 children: PropTypes.node.isRequired
};

export default CompanyProvider;
